<style>
  @keyframes rotateBorder {
    0%   { border-top-color:#3b82f6; border-right-color:transparent; border-bottom-color:transparent; border-left-color:transparent; }
    25%  { border-top-color:transparent; border-right-color:#3b82f6; border-bottom-color:transparent; border-left-color:transparent; }
    50%  { border-top-color:transparent; border-right-color:transparent; border-bottom-color:#3b82f6; border-left-color:transparent; }
    75%  { border-top-color:transparent; border-right-color:transparent; border-bottom-color:transparent; border-left-color:#3b82f6; }
    100% { border-top-color:#3b82f6; border-right-color:transparent; border-bottom-color:transparent; border-left-color:transparent; }
  }
  @media (prefers-color-scheme: dark) {
    @keyframes rotateBorder {
      0%   { border-top-color:#60a5fa; border-right-color:transparent; border-bottom-color:transparent; border-left-color:transparent; }
      25%  { border-top-color:transparent; border-right-color:#60a5fa; border-bottom-color:transparent; border-left-color:transparent; }
      50%  { border-top-color:transparent; border-right-color:transparent; border-bottom-color:#60a5fa; border-left-color:transparent; }
      75%  { border-top-color:transparent; border-right-color:transparent; border-bottom-color:transparent; border-left-color:#60a5fa; }
      100% { border-top-color:#60a5fa; border-right-color:transparent; border-bottom-color:transparent; border-left-color:transparent; }
    }
  }
  :host {
  display: inline-block;
  margin: 0 !important;
  padding: 0 !important;
}

:host .mat-menu-panel {
  margin: 0 !important;
}

:host .mat-menu-content {
  padding: 0 !important;
}

/* Reset de botones dentro del menú */
:host button {
  background: none !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  outline: none !important;
}
</style>

<div class="relative flex items-center justify-center w-9 h-9">
  <button
    mat-icon-button
    class="!flex !items-center !justify-center !p-0 w-full h-full transition"
  [matMenuTriggerFor]="menuNotificaciones"
  (menuOpened)="abrirMenuNotificaciones()"    
  matTooltip="Notificaciones">
    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-blue-900 dark:text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
      <path d="M18.75 9.71v-.705C18.75 5.136 15.726 2 12 2S5.25 5.136 5.25 9.005v.705a4.4 4.4 0 0 1-.692 2.375L3.45 13.81c-1.011 1.575-.239 3.716 1.52 4.214a25.8 25.8 0 0 0 14.06 0c1.759-.498 2.531-2.639 1.52-4.213l-1.108-1.725a4.4 4.4 0 0 1-.693-2.375Z" />
      <path stroke-linecap="round" d="M7.5 19c.655 1.748 2.422 3 4.5 3s3.845-1.252 4.5-3M12 6v4" opacity=".5" />
    </svg>

    <!-- badge -->
    <ng-container *ngIf="(unreadCount$ | async) as contadorNoLeidas">
      <span *ngIf="contadorNoLeidas > 0"
            class="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 md:w-5 md:h-5 text-xs font-bold text-white bg-red-500 rounded-full z-10">
        {{ contadorNoLeidas > 99 ? '99+' : contadorNoLeidas }}
      </span>
    </ng-container>
  </button>
</div>

<mat-menu #menuNotificaciones="matMenu" xPosition="before" yPosition="below" [overlapTrigger]="false"
          class="!w-[calc(100vw-20px)] !max-w-[400px] sm:!w-[400px] !m-0 !p-0">
  <div class="w-full max-h-[500px] flex flex-col rounded-md shadow-lg bg-white dark:bg-[#0a1628] dark:border dark:border-blue-500/20 !m-0 !p-0"
       (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="px-4 pt-3 border-b border-gray-200 dark:border-blue-500/20">
      <h3 class="text-sm font-semibold text-gray-900 dark:text-white">Notificaciones</h3>
      <div class="flex items-center space-x-4 mt-2">
        <button (click)="cambiarPestana('no-leidas')"
                [ngClass]="pestanaActiva === 'no-leidas'
                  ? 'text-sm font-semibold text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 pb-2'
                  : 'text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white pb-2'">
          No leídas
          <ng-container *ngIf="(unreadCount$ | async) as c">
            <span *ngIf="c > 0" class="ml-1.5 px-2 py-0.5 text-xs bg-red-500 text-white rounded-full">{{ c }}</span>
          </ng-container>
        </button>

        <button (click)="cambiarPestana('leidas')"
                [ngClass]="pestanaActiva === 'leidas'
                  ? 'text-sm font-semibold text-blue-600 dark:text-blue-400 border-b-2 border-blue-600 pb-2'
                  : 'text-sm font-medium text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-white pb-2'">
          Leídas
        </button>
      </div>
    </div>

    <!-- Body -->
<div class="max-h-[360px] overflow-y-auto">
      <!-- Loading vacío -->
      <div *ngIf="cargando && notificacionesMostradas.length === 0"
           class="p-8 text-center flex flex-col items-center justify-center">
        <mat-spinner diameter="30"></mat-spinner>
        <p class="text-sm text-gray-500 dark:text-gray-400 mt-3">Cargando...</p>
      </div>

      <!-- Empty state -->
      <div *ngIf="!cargando && notificacionesMostradas.length === 0"
           class="p-8 text-center flex flex-col items-center justify-center">
        <mat-icon class="!w-12 !h-12 text-gray-300 dark:text-gray-600">notifications_off</mat-icon>
        <p class="text-sm font-medium mt-2 text-gray-600 dark:text-gray-300">
          {{ pestanaActiva === 'no-leidas' ? 'Todo al día' : 'No hay notificaciones leídas' }}
        </p>
        <p class="text-xs text-gray-400 dark:text-gray-500">
          {{ pestanaActiva === 'no-leidas' ? 'No tienes notificaciones pendientes.' : 'Las notificaciones que leas aparecerán aquí.' }}
        </p>
      </div>

      <!-- Lista -->
      <div *ngIf="notificacionesMostradas.length > 0">
        <div *ngFor="let notificacion of notificacionesMostradas; trackBy: trackByNotificationId"
             class="group px-4 py-3 border-b border-gray-100 dark:border-blue-500/10 hover:bg-gray-50 dark:hover:bg-blue-800/10 transition-colors cursor-pointer flex items-start space-x-3 relative">
          <div class="flex-shrink-0">
            <div class="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-800 flex items-center justify-center">
              <span class="text-xs font-semibold text-blue-600 dark:text-blue-200">
                {{ getInitials(notificacion.senderName || 'S') }}
              </span>
            </div>
          </div>
<div class="flex-1 min-w-0">
            <!-- Sender name agregado aquí -->
            <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">
              {{ notificacion.senderName }}
            </p>
            
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 dark:text-white truncate pr-2">
                {{ notificacion.titulo }}
              </p>

              <div class="flex items-center gap-1">
                <span
                  class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                  [ngClass]="getTipoBadgeClass(notificacion.tipo)">
                  {{ notificacion.tipo }}
                </span>

                <button *ngIf="pestanaActiva === 'no-leidas'"
                        (click)="marcarComoLeida(notificacion, $event)"
                        mat-icon-button
                        class="w-7 h-7 leading-7 text-gray-500 hover:text-blue-600 hover:bg-blue-100 dark:hover:bg-blue-900"
                        matTooltip="Marcar como leída">
                  <mat-icon class="!text-base">done</mat-icon>
                </button>
              </div>
            </div>

            <p class="text-sm text-gray-600 dark:text-gray-300 mt-1 line-clamp-2">
              {{ notificacion.mensaje }}
            </p>
            <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">
              {{ formatearFecha(notificacion.fechaCreacion) }}
            </p>
          </div>

          <!-- acción rápida -->
         <!--
<button *ngIf="pestanaActiva === 'no-leidas'" ... class="absolute ... opacity-0 group-hover:opacity-100 ...">
  <mat-icon class="!text-base">done</mat-icon>
</button>
-->
        </div>
      </div>

      <!-- Paginación “cargar más” -->
      <div class="p-2 text-center">
        <button *ngIf="!isLastPage && !cargando"
                (click)="cargarMasNotificaciones()"
                class="text-xs text-blue-600 dark:text-blue-400 hover:underline font-medium">
          Cargar más...
        </button>
        <div *ngIf="cargando && notificacionesMostradas.length > 0">
          <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
        </div>
      </div>
    </div>
    <!-- Footer con reset completo de estilos -->
    <div class="px-4 py-3 border-t border-gray-200 dark:border-blue-500/20 bg-gray-50 dark:bg-blue-900/20 flex items-center justify-between !m-0">
      <button class="text-sm text-blue-600 dark:text-blue-400 hover:underline font-medium !p-0 !m-0 !bg-transparent !border-0 !outline-0"
              (click)="marcarTodoComoLeido()">
        Marcar todo como leído
      </button>
      <button class="text-sm text-blue-600 dark:text-blue-400 hover:underline font-medium !p-0 !m-0 !bg-transparent !border-0 !outline-0"
              (click)="verTodasLasNotificaciones()">
        Ver todas
      </button>
    </div>
  </div>
</mat-menu>
